/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GroupControllerUpdateUserGroupPermissionRequest interface.
 */
export function instanceOfGroupControllerUpdateUserGroupPermissionRequest(value) {
    return true;
}
export function GroupControllerUpdateUserGroupPermissionRequestFromJSON(json) {
    return GroupControllerUpdateUserGroupPermissionRequestFromJSONTyped(json, false);
}
export function GroupControllerUpdateUserGroupPermissionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'permissionId': json['permissionId'] == null ? undefined : json['permissionId'],
        'permissionLevel': json['permissionLevel'] == null ? undefined : json['permissionLevel'],
    };
}
export function GroupControllerUpdateUserGroupPermissionRequestToJSON(json) {
    return GroupControllerUpdateUserGroupPermissionRequestToJSONTyped(json, false);
}
export function GroupControllerUpdateUserGroupPermissionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'permissionId': value['permissionId'],
        'permissionLevel': value['permissionLevel'],
    };
}
